import { useEffect } from 'react';
import { useMatches } from 'react-router';
import type { RouteHandle, RouteId } from '~/route-constants';

let currentRouteId: RouteId | null = null;

export function getCurrentRouteId(): RouteId | null {
  return currentRouteId;
}

export function __setCurrentRouteIdForTesting(id: RouteId | null): void {
  currentRouteId = id;
}

export function useTrackCurrentRoute(): void {
  const matches = useMatches();
  useEffect(() => {
    currentRouteId =
      matches
        .map(m => (m.handle as RouteHandle | undefined)?.routeId)
        .findLast((id): id is RouteId => !!id) ?? null;
  }, [matches]);
}
